import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { routes } from './routes'
import Container from '~/components/Container'
import { ROUTE_PATHS } from '~/constants/routes'
import useSession from '~/hooks/useSession'
import Auth from '~/modules/auth'

const AppRoutes = () => {
  const { isValidSession } = useSession()

  return isValidSession ? (
    <BrowserRouter>
      <Container>
        <Routes>
          {routes.map(({ path, component }) => (
            <Route key={path} path={path} element={component} />
          ))}
          <Route path="/" element={<Navigate to={ROUTE_PATHS.DASHBOARD} />} />
        </Routes>
      </Container>
    </BrowserRouter>
  ) : (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Auth />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default AppRoutes
